var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBootcampjsalarm2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bdkrf8ibya)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#ekbwv7opcb)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.133c-3.957 0-7.166 3.41-7.166 7.615s3.209 7.614 7.167 7.614c3.958 0 7.166-3.409 7.166-7.614 0-4.206-3.208-7.615-7.166-7.615z",
    fill: "url(#b0ry2nloec)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98 1.37a.554.554 0 0 0 .078-.746.48.48 0 0 0-.703-.083L1.688 1.958a.554.554 0 0 0-.078.747.48.48 0 0 0 .703.083L3.98 1.37z",
    fill: "url(#8juhlsb01d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.646.541a.48.48 0 0 0-.703.083.554.554 0 0 0 .079.747l1.666 1.417a.48.48 0 0 0 .703-.083.554.554 0 0 0-.078-.747L12.646.54z",
    fill: "url(#gdh2gfiyde)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 .633a7.293 7.293 0 0 0-3.497.89 1.06 1.06 0 0 0-.046-1.2A.98.98 0 0 0 3.031.16L1.364 1.577a1.054 1.054 0 0 0-.153 1.428.985.985 0 0 0 1.049.364A8.372 8.372 0 0 0 .334 8.748c0 4.452 3.404 8.114 7.667 8.114 4.262 0 7.666-3.662 7.666-8.114a8.372 8.372 0 0 0-1.926-5.379.985.985 0 0 0 1.05-.364 1.054 1.054 0 0 0-.154-1.428L12.97.16a.98.98 0 0 0-1.426.163 1.06 1.06 0 0 0-.046 1.2 7.293 7.293 0 0 0-3.497-.89z",
    stroke: "url(#q1rljr8buf)",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#kwp5b74lhg)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.501 5.915c0-.294-.224-.532-.5-.532s-.5.238-.5.532v2.979a.916.916 0 0 1-.227.607l-.97 1.093c-.19.214-.18.55.021.751a.48.48 0 0 0 .707-.022l.97-1.093c.32-.362.5-.84.5-1.336v-2.98z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b0ry2nloec",
    x1: 8.001,
    y1: 0.425,
    x2: 8.001,
    y2: 16.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF30",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8juhlsb01d",
    x1: 8.001,
    y1: 0.425,
    x2: 8.001,
    y2: 16.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF30",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gdh2gfiyde",
    x1: 8.001,
    y1: 0.425,
    x2: 8.001,
    y2: 16.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF30",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q1rljr8buf",
    x1: 0.834,
    y1: 0.425,
    x2: 16.689,
    y2: 14.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ekbwv7opcb",
    x: -24.166,
    y: -24.576,
    width: 64.334,
    height: 65.938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_402_2553"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_402_2553",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "kwp5b74lhg",
    x: 3.168,
    y: 2.383,
    width: 18.334,
    height: 22.107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_2553"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_2553",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bdkrf8ibya"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v17H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootcampjsalarm2);
export default __webpack_public_path__ + "static/media/Bootcamp js alarm 2.1b256dcdc90dfc7fb2deb264f3c420ea.svg";
export { ForwardRef as ReactComponent };